<template>
  <div id="browser">
    <div class="browser__google-image-area">
      <img class="browser__google-image-area__image"
        src="@/assets/svg/google.png"
      >
    </div>
    <div class="browser__search-area">
      <div class="bar">
        <input class="searchbar" type="text" title="Search"  v-model="keyword" @keypress="onKeypress">
        <a href="#"> <img class="voice" src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Google_mic.svg/716px-Google_mic.svg.png" title="Search by Voice"></a>
      </div>
    </div>
  </div>




</template>
<script>
export default {
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    onKeypress (e) {
      if (e.charCode === 13) { // 엔터키
        this.onSearch()
      }
    },
    onSearch () { // 검색
      if (this.keyword.length) {
        window.open('https://google.com/search?q=' + this.keyword) // 구글 검색창 띄우기
      }
    }
  }
}
</script>

<style lang="scss">

#browser {
  width: 100%;
  height: 100%;
  border-radius: 0px 0px 5px 5px;
  background-color: #fff;
  overflow: hidden;

  .browser__browser-top {
    display: flex;
    width: 100%;
    height: 6%;
    background-color: #eee;
    border-bottom: 1px solid gray;

    .browser__browser-top__address-bar {
      width: 100%;
      height: 60%;
      padding: 5px 10px;
      margin: 7px 5px;
      border-radius: 5px;
      border: 1px solid gray;
      font-weight: bold;
    }
  }

  .browser__google-image-area {
    width: 100%;
    background-color: #fff;
    text-align: center;

    .browser__google-image-area__image {
      width: 20rem;
      margin: 4rem 0 3rem 0;
    }
  }

  .browser__search-area {
    text-align: center;

    .browser__search-area__input {
      border: 1px solid lightgray;
      border-radius: 2px;
      outline: none;
      width: 20rem;
      height: 1.6rem;
      padding: 5px;
      box-shadow: 1px 1px 5px rgba(0, 0, 0, .2);
      transition: .3s;

      &:focus, &:hover {
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .4);
      }
    }

    .browser__search-area__button {
      cursor: pointer;
      outline: none;
      height: 2rem;
      border: none;
      border-radius: 5px;
      margin-left: 5px;
    }
  }
}

.bar{
  margin:0 auto;
  width:575px;
  border-radius:30px;
  border:1px solid #dcdcdc;
}
.bar:hover{
  box-shadow: 1px 1px 8px 1px #dcdcdc;
}
.bar:focus-within{
  box-shadow: 1px 1px 8px 1px #dcdcdc;
  outline:none;
}
.searchbar{
  height:45px;
  border:none;
  width:500px;
  font-size:16px;
  outline: none;

}
.voice{
  height:20px;
  position:relative;
  top:5px;
  left:10px;
}

@media screen and (max-width:599px) {
  #browser{
    height: 70% !important;
  }
  .searchbar{
    width: 80% !important;
  }
  .bar{
    width: 80% !important;
  }
}
</style>
